export default "__VITE_ASSET__DTeQHVYC__"